import { render, staticRenderFns } from "./BundleCouponTable.vue?vue&type=template&id=a2940b34&"
import script from "./BundleCouponTable.vue?vue&type=script&lang=js&"
export * from "./BundleCouponTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2940b34')) {
      api.createRecord('a2940b34', component.options)
    } else {
      api.reload('a2940b34', component.options)
    }
    module.hot.accept("./BundleCouponTable.vue?vue&type=template&id=a2940b34&", function () {
      api.rerender('a2940b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BundleCouponTable.vue"
export default component.exports